"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var camel_1 = require("./camel");

exports.camelCaseIt = camel_1.camelCaseIt;

var constant_1 = require("./constant");

exports.constantCaseIt = constant_1.constantCaseIt;

var dot_1 = require("./dot");

exports.dotCaseIt = dot_1.dotCaseIt;

var kebab_1 = require("./kebab");

exports.kebabCaseIt = kebab_1.kebabCaseIt;

var no_1 = require("./no");

exports.noCaseIt = no_1.noCaseIt;

var pascal_1 = require("./pascal");

exports.pascalCaseIt = pascal_1.pascalCaseIt;

var snake_1 = require("./snake");

exports.snakeCaseIt = snake_1.snakeCaseIt;

var space_1 = require("./space");

exports.spaceCaseIt = space_1.spaceCaseIt;